var paywall = require("./lib/paywall");
setTimeout(() => paywall(13067565), 5000);

require("component-responsive-frame/child");
require("./bc-preroll");
require("./audio");

//scroll watcher nav

let lastUpdateValue;

var onUpdate = function( scroll, $parent ){
    if (scroll !== lastUpdateValue) {
        $parent.find('.text').text( scroll.toFixed(2) );
        $parent.find('.meter').width( scroll + '%' );
        lastUpdateValue = scroll;
    }
}

function start() {
    var scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());
    
    onUpdate(scrollPercent, $(".inner"));

    // call back on self to check again
    window.requestAnimationFrame(start);
}

start();
